import type { SignUpSource } from 'shared/analytics/events'
import { track } from 'shared/analytics/track'
import { getPrivySessionBridge } from '../session-bridge'
import { isPrivyReadyVar } from '../store'

/**
 * Opens the Privy login modal from anywhere in the Privy-free UI (FE-302):
 * header button, game buttons for guests, the demo quota, the referral link,
 * the "sign in" page. `source` is reported as `sign_up_started` (FE-321).
 *
 * The Privy chunk loads lazily, so a click that lands before the session
 * bridge is registered waits for it instead of being dropped.
 */
export const openPrivyLogin = (source: SignUpSource) => {
  track('sign_up_started', { source })
  openWhenReady()
}

const openWhenReady = () => {
  const bridge = getPrivySessionBridge()
  if (bridge) {
    bridge.login()
    return
  }

  const unsubscribe = isPrivyReadyVar.onNextChange(isReady => {
    unsubscribe()
    if (isReady) openWhenReady()
  })
}
